
<div class="crm-entry-buttons primary">
    <div class="v-flex w-100 pl-3 pr-3">
        <!-- edit entry -->
        <div v-if="entry.id !== null && !entry.deleted">
            <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                    <a
                        @click = "onEdit"
                        v-bind = "attrs"
                        v-on   = "on"
                    >
                        <v-icon small color="white"  class="toolbar-button">fas fa-pen</v-icon>
                    </a>
                </template>
                <span>{{ $t("crm.menu.edit") }}</span>
            </v-tooltip>
        </div>
        <!-- edit entry -->

        <!-- show document -->
        <div v-if="entry.id !== null && (isDocument || isMail)" class="ml-0">
            <v-tooltip bottom  >
                <template v-slot:activator="{ on, attrs }">
                    <a
                        v-bind = "attrs"
                        v-on   = "on"
                        @click = "onDocument"
                    >
                        <v-icon small color="white" class="toolbar-button pl-1">fas fa-file</v-icon>
                    </a>
                </template>
                <span>{{ $t("crm.menu.document") }}</span>
            </v-tooltip>
        </div>
        <!-- show document -->

        <v-spacer/>

        <!-- delete entry -->
        <div v-if="entry.id !== null && !entry.deleted">
            <v-tooltip bottom >
                <template v-slot:activator="{ on, attrs }">
                    <a
                        @click = "onDelete"
                        v-bind = "attrs"
                        v-on   = "on"
                    >
                        <v-icon color="white"  class="toolbar-button">fa fa-trash-alt</v-icon>
                    </a>
                </template>
                <span>{{ $t("crm.menu.delete") }}</span>
            </v-tooltip>
        </div>
        <!-- delete entry -->

        <!-- undelete entry -->
        <div v-if="entry.deleted">
            <v-tooltip bottom >
                <template v-slot:activator="{ on, attrs }">
                    <a
                        @click = "onUnDelete"
                        v-bind = "attrs"
                        v-on   = "on"
                    >
                        <v-icon color="white"  class="toolbar-button">fa fa-undo-alt</v-icon>
                    </a>
                </template>
                <span>{{ $t("crm.menu.undelete") }}</span>
            </v-tooltip>
        </div>
        <!-- undelete entry -->

    </div>
</div>
